/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SaveCompanyBankRequest = {
  type: 'CompanyBankAccount',
} as const;
